export const BASENAME = '' // don't add '/' at end off BASENAME
export const BASE_URL = ''
export const BASE_TITLE = ' | CPI'
export const ORIGIN_LOCATION =
  window && window.location && window.location.origin
export const ENV_DEV = 'development'

export const API_URL =
  process.env.NODE_ENV == ENV_DEV
    ? process.env.REACT_APP_DEV_API_URL
    : ORIGIN_LOCATION
export const OpenIDConnect = {
  API_Redirect:
    process.env.NODE_ENV == ENV_DEV
      ? 'http://localhost:3000/auth/oidc'
      : `${ORIGIN_LOCATION}/auth/oidc`,

  API_Redirect_BO:
    process.env.NODE_ENV == ENV_DEV
      ? 'http://localhost:3000/bo/auth/oidc'
      : `${ORIGIN_LOCATION}/bo/auth/oidc`,

  ClientID: ORIGIN_LOCATION.includes('cubicus-web-rct-2.vinci-energies.net')
    ? '4972ebd0-ab84-48b8-b35b-f98c3c6f2f93'
    : ORIGIN_LOCATION.includes('cubicusweb-rct.vinci-energies.net')
    ? '4972ebd0-ab84-48b8-b35b-f98c3c6f2f93'
    : ORIGIN_LOCATION.includes('cubicus-web-qas.vinci-energies.net')
    ? '0dab6d2d-2337-4b88-b17a-1688faf014bf'
    : ORIGIN_LOCATION.includes('cubicus-web-v2.vinci-energies.net')
    ? 'bc9702b6-242b-447f-b6ee-636c619b25ff'
    : '219ebab5-8064-4ca1-a189-e852e3eb104c', // Valeur par défaut
  URL: 'https://login.microsoftonline.com/organizations',
}

export const WS_URL =
  process.env.NODE_ENV == ENV_DEV
    ? process.env.REACT_APP_DEV_API_WS
    : ORIGIN_LOCATION.replace('https://', 'wss://').replace('http://', 'ws://')

export const CONFIG = {
  layout: 'vertical', // vertical, horizontal
  subLayout: '', // null, layout-2, layout-2-2, layout-3, layout-4, layout-4-2, layout-6, layout-8
  collapseMenu: false, // mini-menu
  layoutType: 'menu-dark', // menu-dark, menu-light, dark
  navIconColor: true,
  headerBackColor: 'header-dark', // header-default, header-blue, header-red, header-purple, header-lightblue, header-dark
  navBackColor: 'navbar-dark', // navbar-default, navbar-blue, navbar-red, navbar-purple, navbar-lightblue, navbar-dark
  navBrandColor: 'brand-dark', // brand-default, brand-blue, brand-red, brand-purple, brand-lightblue, brand-dark
  navBackImage: false, // false, navbar-image-1, navbar-image-2, navbar-image-3, navbar-image-4, navbar-image-5
  rtlLayout: false,
  navFixedLayout: true, // only for vertical layouts
  headerFixedLayout: true, // only for vertical layouts
  boxLayout: false,
  navDropdownIcon: 'style1', // style1, style2, style3
  navListIcon: 'style6', // style1, style2, style3, style4, style5, style6
  navActiveListColor: 'active-red', // active-default, active-blue, active-red, active-purple, active-lightblue, active-dark
  navListTitleColor: 'title-red', // title-default, title-blue, title-red, title-purple, title-lightblue, title-dark
  navListTitleHide: false,
  configBlock: true,
  layout6Background:
    'linear-gradient(to right, #A445B2 0%, #D41872 52%, #FF0066 100%)', // used only for pre-layout = layout-6
  layout6BackSize: '', // 'auto' - for background pattern, 'cover' - for background images & used only for pre-layout = layout-6
  jwt: {
    secret: 'SECRET-KEY',
    timeout: '1 days',
  },
  refreshTokenIntervalTimer: 60 * 1000 * 9, // 60s * 1000 millième * 9 min
  idleTimer: 10, // en minutes
  remainingTime: 30, // en secondes
  axiosTimeOut: 1200, // en secondes
}
